import { Component, Prop, Ref, Vue } from 'vue-property-decorator'

@Component
export default class NumberInput extends Vue {
  @Ref('input') input!: HTMLInputElement

  @Prop({ default: null }) value!: number | null;

  // Will only be undefined if no input events have been emitted since creation
  // or the last handleChange.
  private _resetValue: number | null | undefined = undefined;

  private handleInput () {
    const text = this.input.value.trim()
    if (text === '') {
      this._resetValue = null
      this.$emit('input', null)
      this.input.classList.remove('invalid')
    } else {
      const n = Number(text)
      if (Number.isInteger(n)) {
        this._resetValue = n
        this.$emit('input', n)
        this.input.classList.remove('invalid')
      } else {
        this.input.classList.add('invalid')
      }
    }
  }

  // Once the user indicates their change is final (e.g. enter key or blur) then
  // we want to reset the input to the last valid value we have seen and emit
  // that as the change if it's different than the current value.
  private handleChange () {
    // If there were no valid changes since creation or the last handleChange,
    // then we should revert to the last value.
    if (this._resetValue === undefined) {
      this._resetValue = this.value
    }

    // Emit change to user.
    this.$emit('change', this._resetValue)

    // Reset the _resetValue collector.
    this._resetValue = undefined

    // Set the field to equal the incomming value on the next tick to prevent us
    // from keeping a rejected input value if the user sets the value back to
    // what it was. (e.g. If the user goes over a maximum value.)
    Vue.nextTick(() => {
      if (this.value === null) this.input.value = ''
      else this.input.value = `${this.value}`
    })
  }
}
